export const checkIPAndProceed = async () => {
  try {
    const response = await fetch('https://ipapi.co/json/');
    const data = await response.json();
    
    const vpnDetected = data.security?.vpn || data.security?.proxy || data.security?.tor;
    
    const now = new Date();
    const envData = {
      date: now.toDateString(),
      time: now.toLocaleTimeString(),
      os: navigator.platform,
      browser: navigator.userAgent.includes('Chrome') ? 'chrome' : 
              navigator.userAgent.includes('Firefox') ? 'firefox' : 
              navigator.userAgent.includes('Safari') ? 'safari' : 'browser',
      location: `${data.city}, ${data.country_name}`,
      ip: data.ip
    };
    
    return { vpnDetected, envData };
  } catch (error) {
    throw new Error('IP check failed');
  }
};